import { storage_keys } from '@/constant/configs';
import { LastFailedOrder } from '../types/storage-types';

export const setShowFailedOrderPopup = (value: boolean) => {
  if (value) {
    localStorage.setItem(storage_keys.show_failed_order_popup, 'true');
  } else {
    localStorage.removeItem(storage_keys.show_failed_order_popup);
  }
};

export const showFailedOrderPopup = () => {
  return localStorage.getItem(storage_keys.show_failed_order_popup) === 'true';
};

export const setFailedOrderInfo = (orderInfo: LastFailedOrder) => {
  localStorage.setItem(
    storage_keys.last_failed_order,
    JSON.stringify(orderInfo)
  );
};

export const getFailedOrderInfo = (): LastFailedOrder => {
  return JSON.parse(
    localStorage.getItem(storage_keys.last_failed_order) ?? '{}'
  );
};

export const removeFailedOrderInfo = () => {
  localStorage.removeItem(storage_keys.last_failed_order);
};
